import { render, staticRenderFns } from "./HookAside.vue?vue&type=template&id=4ca43757"
import script from "./HookAside.vue?vue&type=script&lang=js"
export * from "./HookAside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports